module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kxq1L"))).then(() => parcelRequire('hEqeo'));